export default "__VITE_ASSET__CDcG$nZd__"